const actionMap = {
  continue: 'Continue',
  break: 'Break',
  doNothing: 'Do nothing',
  endAsSuccess: 'End workflow as success',
  endAsFailure: 'End workflow as failure'
};

const evaluateFlowControlMessage = ({ args }) => {
  const action = args?.action;
  const emitLog = args?.emitLog;
  const sendEmail = args?.sendEmail;
  const actionMessage = actionMap[action] || 'Do nothing';

  if (!emitLog && !sendEmail) {
    return actionMessage;
  }

  const parts = [];
  if (action !== 'doNothing') {
    parts.push(actionMessage);
  }
  if (emitLog) {
    parts.push('Emit log');
  }
  if (sendEmail) {
    parts.push('Send email');
  }

  let result = parts[0];
  for (let i = 1; i < parts.length; i++) {
    result += `, ${parts[i].toLowerCase()}`;
  }

  return result;
};

export default evaluateFlowControlMessage;
